module.exports = __webpack_public_path__ + "static/img/suv-blue.343cdfe.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg/suv-blue.svg
// module id = j8QR
// module chunks = 74